define('views/modules/help/help-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/panel/base-panel',
    'views/modules/help/contact/contact-content',
    'views/modules/help/tutorial/tutorial-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VBasePanel,
    VContactContent,
    VTutorialContent
) {

    var VHelpPanel = VBasePanel.extend({
        header: {
            title: "tutorials:Help & Resources",
            subtitle: "TotalCoaching",
        },
        tabs: [
            // { id: 'tutorial', title: 'Video tutorials', callback: 'showTutorial', active: true },
            { id: 'contact', title: 'tutorials:Help & Resources', callback: 'showContact' }
        ],
        content: {
            contact: VContactContent
            // tutorial: VTutorialContent
        },
        defaultView: 'contact',

        getContentViewOptions: function(options) {
            return _.extend({
                model: this.model,
            }, this.options);
        },

        showContact: function() { this.showContent('contact'); },
        // showTutorial: function() { this.showContent('tutorial'); },

    });

    return VHelpPanel;
});

